import CommonService from "./CommonService.js";
export var commonService;
export function initial() {
    if (!commonService)
        commonService = new CommonService();
    return commonService;
}